import { render, staticRenderFns } from "./modal-statement.vue?vue&type=template&id=49bc2b16&scoped=true"
import script from "./modal-statement.vue?vue&type=script&lang=js"
export * from "./modal-statement.vue?vue&type=script&lang=js"
import style0 from "./modal-statement.vue?vue&type=style&index=0&id=49bc2b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc2b16",
  null
  
)

export default component.exports